/* eslint-disable max-len */

// Funzione che testa se la query cercata è presente
function testSearchString(tvalue, tkey) {
  let control = true;
  for (let x = 0; x < tkey.length; x += 1) {
    if (tvalue.toLowerCase().indexOf(tkey[x]) === -1) {
      control = false;
    }
  }
  return control;
}


// Funzione che inserisce nell'aera il rsultato della ricerca
function showResult($item, img, title, link) {
  $item.append(`<a href="${link}">
    <div class="search-item col-xs-6 col-sm-4 col-md-3 col-lg-2">
      <img src="https://www.gioielloro.it/upload/articoli/thumbs/${img}">
      <p class="search-titolo">
        ${title}
      </p>
    </div>
  </a>`);
}


// Funzione che controlla se il pulsante è presente nell'array
// dei pulsanti esclusi.
function testForKeys(key, arrKey) {
  let control = true;
  for (let x = 0; x < arrKey.length; x += 1) {
    if (arrKey[x] === key) {
      control = false;
    }
  }
  return control;
}


// ========================================================================
// LIVE SEARCH | v. 2.0.0 |
// ========================================================================
(function () {

  let ajaxTimer = 0;

  $('#searchkey').on('keyup', function (e) {

    // Controllo se il pulsante premuto non fa parte dei pulsanti esclusi
    // in caso positivo procedo con la funzione
    if (testForKeys(e.keyCode, [16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 91, 92, 93, 144, 145])) {

      // Controllo se è presente un valore nell'input
      if ($(this).val()) {

        // Controllo se il valore è almeno di 3 caratteri
        if ($(this).val().length > 3) {

          // Prendo il valore inserito nell'input di ricerca e lo converto
          // in lowercas per il confronto. Dopo creo un array con le singole
          // parole in modo da testare per tutti i termini di ricerca
          let searchKey = $(this).val().toLowerCase();
          searchKey = searchKey.split(' ');

          // Fix per evitare la coda di chiamate multiple (live-search)
          clearTimeout(ajaxTimer);

          ajaxTimer = setTimeout(function () {

            // Chiamo il transfer file
            // $.get('https://www.gioielloro.it/search/searchindex.txt', function (data) {

            // necessario come parametro nella chiamata per ignorare l'eventuale cache lato server
            // che andrebbe a caricare un file della live search non aggiornato (cache)
            const timestamp = Math.floor((new Date()).getTime() / 1000);

            $.ajax({
              method: 'GET',
              url: 'https://www.gioielloro.it/search/searchindex.txt?t=' + timestamp,
              username: 'search_gioielloro',
              password: 'PrX2&061*gol',
              success: function (data) {

                // Pulisco l'area del risultato
                $('#search-result-area').html('');

                // Nascondo il vedi tutti i risultati
                $('#see-all-result').addClass('hidden');

                // Divido gli articoli del trasfer file
                const arr = data.split('\n');

                // preparo il counter per limitare i risultati di ricerca
                let limitCounter = 0;

                // Per ogni articolo controllo se è contenuta la query di ricerca
                for (let i = 1; i < arr.length; i += 1) {

                  if (testSearchString(arr[i], searchKey)) {

                    // In caso positivo lo preparo per poter essere mostrato
                    // recuperando i valori in un array.
                    const splitRes = arr[i].split(';');

                    // Mostro il risultato
                    showResult($('#search-result-area'), splitRes[3], splitRes[2], splitRes[4]);

                    // Incremento il counter per il limite di risulati
                    limitCounter += 1;
                  }

                  // Se ci sono più di 10 risulati smetto di cercare
                  if (limitCounter > 11) {
                    // Mostro il link per vedere tutti i risultati di ricerca
                    $('#see-all-result').removeClass('hidden');
                    break;
                  }
                }

              }
            });

            // });
          }, 300);
        }

        // Il campo è vuoto, quindi pulisco l'area del risultato
      } else {
        $('#search-result-area').html('');
        $('#see-all-result').addClass('hidden');
      }
    }
  });
}());


// Apro l'overlay di ricerca
$('.function-search').on('click', function () {
  $('#fullscreen-search').toggleClass('hidden');
  $('#searchkey').focus();
});

// Chiudo l'overlay di ricerca
$('.close-search').on('click', function () {
  $('#fullscreen-search').toggleClass('hidden');
  $('#searchkey').val('');
  $('#search-result-area').html('');
});

// Faccio il submit della form al click su vedi tutti i risultati
$('#see-all-result h6').on('click', function () {
  $('#live-search').submit();
});
